import React, {useState, useEffect} from "react";
import styled, {keyframes} from "styled-components";

import {colors} from "nxtconstants";

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const RotatingText = ({words}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return <AnimatedText>{words[currentWordIndex]}</AnimatedText>;
};

const AnimatedText = styled.div`
  color: ${colors.rajah};
  animation: ${fadeInOut} 4s infinite;
`;

export default RotatingText;
